/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useMemo, useState, useCallback } from 'react'

import { text } from '@groovehq/internal-design-system/lib/styles/elements'
import NumberField from '@groovehq/internal-design-system/lib/components/NumberField/NumberField'
import { moneyString, shopifyMoneyString } from 'util/currency'
import { styles as mainStyles } from 'components/integrations/ShopifyV2WidgetCard/styles'

import Product from '../Product/Product'
import { styles } from '../CreateOrderDrawer/styles'
import { convertFromCents, updateItemTotal } from '../order.util'

const createCustomProductCell = original => {
  const { image, name } = original
  const price = original?.discountedUnitPriceSet?.shopMoney?.amount * 1

  return (
    <Product name={name} image={image ? image.src : null}>
      {original.price.currency}
      {price}
    </Product>
  )
}

const createProductCell = ({ value, row: { original } }) => {
  if (!value) return createCustomProductCell(original)
  const { displayName, productURL, sku, price } = value
  const { image, product } = original
  const currency = original.price.currency

  const name = product.hasOnlyDefaultVariant ? original.name : displayName

  const info = (
    <>
      <span css={text.styles.uppercase}>
        {sku}
        &thinsp;&thinsp;&middot;&thinsp;&thinsp;
      </span>
      <span css={mainStyles.moneyString}>
        {shopifyMoneyString({ currencyCode: currency, amount: price })}
      </span>
    </>
  )

  return (
    <Product
      name={name}
      image={image ? image.originalSrc : null}
      productURl={productURL}
    >
      {info}
    </Product>
  )
}

const QuantityCell = ({
  value,
  updateData,
  onEdit,
  row: { index, original },
  column: { id },
}) => {
  const [feedback, setFeedback] = useState({})
  // Handle change quantity and change item total accordingly
  const handleChange = ({ target }) => {
    updateData(index, id, target.value)
  }

  return (
    <NumberField
      css={styles.numberField}
      value={value}
      onChange={handleChange}
      min={0}
      hasMaxHint
      max={original.currentQuantity}
      {...feedback}
    />
  )
}

const createTotalCell = ({ value, row: { original } }) => {
  const { refundQuantity } = original
  const price = original?.discountedUnitPriceSet?.shopMoney?.amount * 1
  const total = price * refundQuantity * 100
  return (
    <span css={[text.styles.fontMedium, mainStyles.moneyString]}>
      {moneyString({ currencyCode: original.price.currency, amount: total })}
    </span>
  )
}

const useColumns = () => {
  const columns = useMemo(() => {
    return [
      {
        Header: 'Product',
        accessor: 'variant',
        Cell: createProductCell,
        width: '70%',
        disableSortBy: true,
      },
      {
        Header: 'Quantity',
        accessor: 'refundQuantity',
        Cell: QuantityCell,
        disableSortBy: true,
        width: '115px',
      },
      {
        Header: 'Total',
        Cell: createTotalCell,
        accessor: 'total',
        disableSortBy: true,
        width: '20%',
      },
    ]
  }, [])

  return columns
}

export default useColumns
